import React from 'react';
import Row from '../../../../shared/components/Row';
import { I18nUtils } from '../../../../../i18n/I18nUtils';
import { WorkerForm } from '../WorkerForm';
import { WorkerFormValues } from '../WorkerFormValues';
import { WorkerCreateRequest } from './worker-create/WorkerCreateRequest';
import { WorkerCreateTask } from './worker-create/WorkerCreateTask';
import Alert from 'react-s-alert';
import { PsRoutes } from '../../../../shared/routing/Routes';
import { bindActionCreators } from 'redux';
import * as navigationActions from '../../../../shared/utils/NavigationActions';
import { connect } from 'react-redux';
import { CurrentUser } from '../../../../shared/model/CurrentUser';

export class WorkerCreate extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            workerValues: WorkerFormValues.fromCurrentUser(props.currentUser),
        };
    }

    render() {
        const { workerValues } = this.state;
        const initialValues = workerValues.initialValues();

        return (
            <React.Fragment>
                <Row clearfix>
                    <WorkerForm
                        title={I18nUtils.tr('TR_NUEVO_TRABAJADOR')}
                        initialValues={initialValues}
                        onSubmit={this.createWorker}
                    />
                </Row>
            </React.Fragment>
        );
    }

    createWorker = (values) => {
        const request = new WorkerCreateRequest(values);

        new WorkerCreateTask(request)
            .onSuccess(() => {
                Alert.success(I18nUtils.tr('TR_TRABAJADOR_CREADO_CORRECTAMENTE'));
                this.props.navigation.goTo(PsRoutes.MY_CONTRACTORS_WORKERS);
            })
            .onFail((error) => Alert.error(error))
            .execute();
    };
}

const mapStateToProps = (state) => ( { currentUser: CurrentUser.fromReduxState(state) } );

const mapDispatchToProps = (dispatch) => ( { navigation: bindActionCreators(navigationActions, dispatch) } );

export const WorkerCreateContent = connect(mapStateToProps, mapDispatchToProps)(WorkerCreate);

WorkerCreateContent.propTypes = {};

WorkerCreateContent.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/my-contractors/worker/form/create/WorkerCreateContent.jsx